import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Column, ColumnProps } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React, { RefObject } from 'react';
import { RouterProps } from 'react-router';
import { Flex } from 'reflexbox';

import qs from 'qs';
import { DataSource } from '../../models/DataSource';
import { DataTableFilterService } from '../../services/DataTableFilterService';
import { MonitoringRestService } from '../../services/MonitoringRestService';
import { DependencyContainer } from '../../utils/DependencyInjection';
import { IKioskFilterContainerValue, KioskFilterContainer } from './KioskFilterContainer';
import { DateHelper } from '../../utils/DateHelper';
import { Growl } from 'primereact/growl';

export interface IKioskContainerQuery {
  filters: IKioskFilterContainerValue;
}

@observer
export class KioskContainer extends React.Component<RouterProps, any> {
  dataTableFilterService = DependencyContainer.get(DataTableFilterService);
  monitoringRestService = DependencyContainer.get(MonitoringRestService);

  data; growl;
  tableData;
  dataSource = new DataSource<any>();
  refFilter: RefObject<KioskFilterContainer> = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      exportExcelLoading: false,
      showExportDialog: false,
    }

    this.exportData = this.exportData.bind(this);
  }

  componentDidMount() {
    const queryFilter = (this.props.history.location.search)
      ? qs.parse(
        this.props.history.location.search.substr(1),
      ) as any
      : {} as any;

    if (queryFilter && queryFilter.filters) {
      if (this.refFilter.current) {
        const newFilters = this.refFilter.current.setFormValues(queryFilter.filters);
        this.loadData(newFilters);
      }
    }
  }

  loadData(filterParams: any = null) {
    const fParams = (filterParams)
      ? Object.assign({}, filterParams)
      : Object.assign({}, this.refFilter.current!.formValues);

    if (fParams.startDate) fParams.startDate = DateHelper.formatLocalDateForQueryParam(fParams.startDate);
    if (fParams.endDate) fParams.endDate = DateHelper.formatLocalDateForQueryParam(fParams.endDate);

    this.dataSource.loading = true;
    this.monitoringRestService
      .post('kiosk/print-logs', fParams)
      .subscribe(
        response => {
          this.data = response;
          this.dataSource.setData(response);
          this.dataSource.setTotal(response.length);
        },
        null,
        () => {
          this.dataSource.loading = false;
        },
      );
  }

  exportData() {
    this.tableData.exportCSV();
    let msg = { severity: 'success', summary: 'Success Message', detail: 'Export Success' };
    this.growl.show(msg);
  }

  render() {
    var header = <div style={{ textAlign: 'left' }}><Button type="button" icon="pi pi-external-link" iconPos="left" label="CSV" onClick={this.exportData}></Button></div>;
    const footer = 'Total data: ' + this.dataSource.total.toLocaleString();

    return (
      <div>
        <Flex className="card w-full">
          <Flex className="w-full" column>
            <Growl ref={el => this.growl = el} style={{ marginTop: '75px' }} />
            <KioskFilterContainer ref={this.refFilter} />
            <br />
            <Flex>
              <Button
                className="p-button-success mr-2"
                label="Tampilkan"
                onClick={
                  () => {
                    this.loadData();
                  }
                }
              />
            </Flex>
          </Flex>
        </Flex>

        <div className="card">
          <DataTable
            emptyMessage={'Tidak ada data untuk ditampilkan.'}
            scrollable={true}
            scrollHeight="550px"
            style={{ width: '100%' }}
            className="mt-4"
            value={this.dataSource.data}
            loading={this.dataSource.loading}
            header={header} ref={(el) => { this.tableData = el; }}
            footer={footer}>
            <Column
              field="trackingSite"
              header="Gerai"
              sortable={false}
              style={{ width: '150px' }}
            />
            <Column
              field="printCount"
              header="Total Print"
              sortable={false}
              body={(rowData, column: ColumnProps) => {
                const colValue = rowData[column.field!];
                const fmtValue = colValue ? colValue.toLocaleString() : "-";
                return <span>{fmtValue}</span>;
              }}
              style={{ width: '100px' }}
            />
            <Column
              field="avgPrintCount"
              header="Avg Print"
              sortable={false}
              body={(rowData, column: ColumnProps) => {
                const colValue = rowData[column.field!];
                const fmtValue = colValue ? colValue.toLocaleString() : "-";
                return <span>{fmtValue}</span>;
              }}
              style={{ width: '100px' }}
            />
          </DataTable>
        </div>
      </div>
    );
  }
}
